import styled, { createGlobalStyle } from 'styled-components'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'
import { XSMALL_BREAKPOINT } from '../../../style'

export const H0 = styled.h1`
  font-weight: 900;
  font-size: 2.25rem;
  line-height: 1.625rem;
  color: ${colors.black1};
  margin-bottom: 0.625rem;

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    font-size: 1.25rem;
    line-height: 1.75rem;
    margin-top: 1rem;
  }
`
export const H1 = styled.h2`
  font-weight: 900;
  font-size: 1.5rem;
  line-height: 2.125rem;
  color: ${colors.black1};
  margin-bottom: 0.375rem;

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
`
export const H3 = styled.h4`
  font-size: 1.125rem;
  font-weight: 900;
  line-height: 1.75rem;
  color: ${colors.black1};
  margin-bottom: 0.625rem;
`
export const H4 = styled.h5`
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.625rem;
  margin-bottom: 1rem;
  color: ${colors.black1};

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    font-size: 0.875rem;
    line-height: 1.5rem;
  }
`
export const H5 = styled.h6`
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.5rem;
  color: ${colors.black1};
`
export const H6 = styled.p`
  font-size: 0.75rem;
  line-height: 1.375rem;
  margin: 0;
`
export const H8 = styled.h5`
  font-size: 0.625rem;
  font-weight: 400;
  line-height: 0.75rem;
`
export const A = styled.a`
  color: ${colors.adaptBlue};

  &:hover {
    color: ${colors.adaptBlue};
  }
`
export const PageSection = styled.div`
  margin-bottom: 3rem;
`
export const WhiteBox = styled.div`
  background: white;
  border: 1px solid ${colors.gandalf};
  box-sizing: border-box;
  border-radius: 0.75rem;
  padding: 1.688rem 1.5rem;
  color: ${colors.black1};

  h3 {
    font-weight: 700;
    font-size: 0.875rem;
    line-height: 1.5rem;
  }
  p {
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1.375rem;
    color: ${colors.dawn};
  }
`
export const CustomTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: none;
  color: ${colors.black1};
  font-size: 0.875rem;
  line-height: 1.5rem;

  strong {
    font-weight: 700;
  }

  thead {
    border-bottom: 1px solid ${colors.gandalf};
    tr {
      border: none;
    }
  }

  tbody {
    padding-top: 1rem;

    tr {
      padding-bottom: 2rem;
    }

    tr:last-child {
      /* stylelint-disable */
      .title {
        padding-bottom: 0;
      }
      /* stylelint-enable */
    }
  }

  th {
    padding-bottom: 1rem;
    font-size: 0.688rem;
    font-weight: 700;
    line-height: 0.875rem;
    letter-spacing: 0.087rem;
    text-transform: uppercase;

    &:first-child {
      padding: 0 1.5rem 0 0.5rem;
      max-width: 2rem;
      text-align: center;
      vertical-align: top;
    }
  }

  .payment {
    padding-left: 9px;
  }

  td {
    font-size: 1rem;
    line-height: 1.625rem;
    font-weight: 900;

    &:first-child {
      font-size: 0.875rem;
      font-weight: 400;
      line-height: 1.5rem;
      white-space: nowrap;
      padding: 0 1.5rem 0 0.5rem;
      max-width: 2rem;
      text-align: center;
    }

    &:last-child {
      width: 1%;
      white-space: nowrap;
    }

    span {
      font-size: 0.625rem;
      font-weight: 400;
      line-height: 0.75rem;
    }
    padding-bottom: 0;
  }

  .title {
    font-size: 1rem;
    line-height: 1.625rem;
    font-weight: 400;
    max-width: 9rem;
    padding-right: 1.5rem;
    padding: 1rem 0;

    div {
      color: ${colors.dawn};
      font-size: 0.875rem;
      line-height: 1.5rem;
      font-weight: 400;
    }

    span {
      display: none;
      position: absolute;
      right: -0.75rem;
      top: 0.125rem;
      background: ${colors.alert};
      width: 0.375rem;
      height: 0.375rem;
      border-radius: 50%;
    }

    .overdue {
      display: block;
    }

    a {
      color: ${colors.black1};
      position: relative;
      white-space: nowrap;

      &:hover {
        color: ${colors.black1};
        text-decoration: underline;
      }
    }
  }

  .paid {
    font-size: 0.625rem;
    font-weight: 700;
    line-height: 0.875rem;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    color: #36c17e;
    min-width: 5.5rem;

    &:last-child {
      padding: 0;
    }

    img {
      margin-right: 0.375rem;
    }
  }

  .status {
    font-size: 0.625rem;
    font-weight: 700;
    line-height: 0.875rem;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    &.red {
      color: ${colors.alert};
    }
    &.yellow {
      color: #e59f36;
    }
  }

  .due {
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5rem;
    white-space: nowrap;

    &.center {
      text-indent: 2.25rem;
    }
  }

  button {
    margin-right: 0.75rem;
    span {
      font-size: 0.875rem;
    }
  }
`
export const BillingWrap = styled.div`
  margin-bottom: 2.25rem;

  a {
    color: ${colors.adaptBlue};
  }
`
export const StyledH5 = styled(H5 as any)`
  font-weight: 700;
  margin-bottom: 0.25rem;
`
export const LightParagraph = styled.p`
  font-size: 0.75rem;
  line-height: 1.375rem;
  color: ${colors.dawn};
  margin-bottom: 1.25rem;
`
export const CurrentSpend = styled.div`
  display: flex;
  align-items: self-end;
  justify-content: space-between;
  color: ${colors.black1};
  padding-top: 0.5rem;

  h5 {
    margin: 0;
  }

  p {
    text-align: right;
  }
`
export const BackLink = styled.div`
  padding-left: 17px;
  cursor: pointer;
  background: url(https://res.cloudinary.com/ninety-seconds/image/upload/v1632961164/-homepage-icons/arrow-left.svg)
    no-repeat center left;
  background-size: 7px;
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.75rem;
  color: ${colors.black1};
  margin-bottom: 2.25rem;

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    margin-bottom: 1.5rem;
    margin-top: 1rem;
  }
`
export const TableWhiteBox = styled(WhiteBox as any)`
  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    display: none;
  }
`
export const GlobalStyles = createGlobalStyle`
  .ant-select-dropdown-menu-item:hover {
    && {
      background: ${colors.adaptBlue};
      color: white;
    }
  }
`

export const MobileInvoices = styled.div`
  overflow-x: scroll;
  margin: 0 -20px;
  padding: 0 20px;
  display: none;

  & {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
  &::-webkit-scrollbar {
    display: none;
  }

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    display: flex;
  }
`
export const MobileHistoryInvoices = styled.div`
  display: none;

  > div {
    margin-bottom: 1rem;
    max-width: 100%;
    width: auto;
    margin-right: 0;
  }

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    display: block;
  }
`

export const MobiileInvoicesCard = styled.div`
  background: white;
  border: 1px solid #f1f1f1;
  box-sizing: border-box;
  border-radius: 0.75rem;
  padding: 1rem 1.5rem;
  color: ${colors.black1};
  width: 18.4rem;
  min-width: 18.4rem;
  margin-right: 1rem;
  position: relative;

  &:last-child {
    margin-right: 0;
  }

  h6,
  h5 {
    margin: 0;
  }
  span {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`
export const Hr = styled.hr`
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
  background-color: ${colors.dawn};
`
export const MobileH6 = styled(H6 as any)`
  font-weight: 900;
  margin-left: 2px;
`
export const FlexRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
export const UpperText = styled.p`
  font-size: 0.688rem;
  font-weight: 700;
  line-height: 0.875rem;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin: 0;
`
export const CardHead = styled.div`
  margin-bottom: 0.75rem;
`
export const CardFooter = styled.div`
  padding-top: 0.5rem;

  p {
    margin-right: 0.375rem;
  }
`
export const InvoiceStatus = styled(UpperText as any)`
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;

  &.red {
    color: ${colors.alert};
  }

  &.yellow {
    color: #e59f36;
  }
`
export const MobileH5 = styled(H5 as any)`
  a {
    position: relative;
    color: ${colors.black1};
  }

  span {
    display: none;
    position: absolute;
    right: -0.75rem;
    top: 0.125rem;
    background: ${colors.alert};
    width: 0.375rem;
    height: 0.375rem;
    border-radius: 50%;
  }

  .overdue {
    display: block;
  }
`



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/BrandDashboardPayments/BrandDashboardPayments.style.tsx